import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const LinkListListingView = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="link-list-listing">
      {items.map((item) => (
        <div key={item['@id']} className="link-list-listing__item">
          <UniversalLink href={item['@id']}>
            {item.title || item.id}
          </UniversalLink>
        </div>
      ))}
    </div>
  );
};

LinkListListingView.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      '@id': PropTypes.string.isRequired,
      title: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
};

export default LinkListListingView;
